<template>
  <div class="rename-transfer-container">
    <el-tabs v-model="activeSubTab">
      <!-- 改名日志 -->
      <el-tab-pane label="改名记录查询" name="rename">
        <div class="query-form">
          <el-input v-model="searchUserName" placeholder="请输入原始角色名(fromName)" style="width:320px"></el-input>
          <el-button type="primary" @click="searchRename" :loading="renameLoading">查询改名记录</el-button>
        </div>
        <el-table :data="renameList" border stripe class="data-table">
          <el-table-column prop="serverTime" label="时间"></el-table-column>
          <el-table-column prop="fromName" label="原角色名"></el-table-column>
          <el-table-column prop="toName" label="新角色名"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 角色转移日志 -->
      <el-tab-pane label="角色转移查询" name="transfer">
        <div class="query-form">
          <el-input v-model="searchUserName" placeholder="请输入原始角色名(fromName)" style="width:320px"></el-input>
          <el-button type="primary" @click="searchTransfer" :loading="transferLoading">查询转移记录</el-button>
        </div>
        <el-table :data="transferList" border stripe class="data-table">
          <el-table-column prop="serverTime" label="时间"></el-table-column>
          <el-table-column prop="fromName" label="原角色名"></el-table-column>
          <el-table-column prop="toName" label="转移之前的账号"></el-table-column>
          <el-table-column prop="fromIp" label="转移之后的账号"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { LOG_API } from '@/utils/apiBase';
import { ref, defineProps } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'

const props = defineProps({
  serverId: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const activeSubTab = ref('rename')
const searchUserName = ref('')

const renameLoading = ref(false)
const renameList = ref([])

const transferLoading = ref(false)
const transferList = ref([])

// 查询改名记录
const searchRename = async () => {
  if (!props.serverId) {
    ElMessage.warning("请先选择服务器！")
    return
  }
  if (!searchUserName.value) {
    ElMessage.warning("请输入要查询的角色名！")
    return
  }
  renameLoading.value = true
  try {
    const res = await axios.get(`${LOG_API}/api/drop/ChangeuserName`, {
      params: {
        serverId: props.serverId,
        userName: searchUserName.value
      }
    })
    renameList.value = res.data || []
    if (renameList.value.length === 0) {
      ElMessage.info("未查询到改名数据")
    }
  } catch (err) {
    console.error(err)
    ElMessage.error("查询改名记录失败")
  } finally {
    renameLoading.value = false
  }
}

// 查询角色转移记录
const searchTransfer = async () => {
  if (!props.serverId) {
    ElMessage.warning("请先选择服务器！")
    return
  }
  if (!searchUserName.value) {
    ElMessage.warning("请输入要查询的角色名！")
    return
  }
  transferLoading.value = true
  try {
    const res = await axios.get(`${LOG_API}/api/drop/TranteUserName`, {
      params: {
        serverId: props.serverId,
        userName: searchUserName.value
      }
    })
    transferList.value = res.data || []
    if (transferList.value.length === 0) {
      ElMessage.info("未查询到转移数据")
    }
  } catch (err) {
    console.error(err)
    ElMessage.error("查询角色转移记录失败")
  } finally {
    transferLoading.value = false
  }
}
</script>

<style scoped>
.rename-transfer-container{
  padding:10px;
}
.query-form{
  display:flex;
  gap:12px;
  align-items:center;
  margin-bottom:16px;
}
.data-table{
  width:100%;
}
</style>
